/*******************************************************************************
  ShowRounds.js

  Author: Advait

*******************************************************************************/

import React, { Component } from "react";

import DownloadRoundData from "./DownloadRoundData";
import DownloadCumulative from "./DownloadCumulative";
import "../index.css";

class ShowRounds extends Component {
  //***************************************************************************
  // render the UI
  //***************************************************************************
  render() {
    return (
      <div>
        {this.props.siteid && !this.props.hideInspectionPage && (
          <>
            <DownloadRoundData
              roundType="inspections"
              siteid={this.props.siteid}
              sitename={this.props.sitename}
              tenantName={this.props.tenantName}
              sysAdmin={this.props.sysAdmin}
            />
            <DownloadCumulative
              roundType="inspections"
              siteid={this.props.siteid}
              siteName={this.props.sitename}
              tenantName={this.props.tenantName}
              sysAdmin={this.props.sysAdmin}
            />
          </>
        )}
        <DownloadCumulative
          roundType="monitoring"
          siteid={this.props.siteid}
          siteName={this.props.sitename}
          tenantName={this.props.tenantName}
          sysAdmin={this.props.sysAdmin}
        />

        {this.props.siteid && !this.props.hideSecurityPatrolPage && (
          <DownloadRoundData
            roundType="patrols"
            siteid={this.props.siteid}
            sitename={this.props.sitename}
            tenantName={this.props.tenantName}
            sysAdmin={this.props.sysAdmin}
          />
        )}
      </div>
    );
  }
}
export default ShowRounds;
